var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M26.279 23.24a1 1 0 011.388 1.434l-.09.087-6.01 5.127a1 1 0 01-1.29.006l-.09-.083-2.917-3.112a1 1 0 011.368-1.454l.092.086 2.264 2.415 5.285-4.507z", fill: "currentColor", fillRule: "nonzero" }),
            React.createElement("path", { d: "M20.5 13.5c1.377 0 2.667.37 3.776 1.018a7.54 7.54 0 013.32 4.042A3.465 3.465 0 0130.5 17c.966 0 1.841.392 2.475 1.025A3.489 3.489 0 0134 20.5a3.486 3.486 0 01-1.072 2.518c.457.035.911.127 1.353.278a5.509 5.509 0 012.697 2.01A5.473 5.473 0 0138 28.5a5.482 5.482 0 01-1.541 3.818 5.483 5.483 0 01-3.744 1.678h0L14.539 34a6.028 6.028 0 01-3.933-1.912A5.988 5.988 0 019 28a5.97 5.97 0 01.931-3.212 6.029 6.029 0 012.52-2.222h0l.629-.295-.057-.691a7.477 7.477 0 012.174-5.883A7.477 7.477 0 0120.5 13.5z", stroke: "currentColor", strokeWidth: 2 }))));
});
